import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';

/** Mobile-only purchase bar that appears once the visitor scrolls past the hero. */
export function StickyBuyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setIsVisible(window.scrollY > window.innerHeight * 0.9);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-310" data-mp="3vebqhwrh8jsw">
      {isVisible && <motion.div initial={{
      y: 72,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 72,
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-night-600 bg-night-950 px-4 py-3 sm:hidden" data-id="element-311" data-mp="3vd0rsbcw228n">
          <div className="flex items-center justify-between gap-4" data-id="element-312" data-mp="1w3c5pgmf2w5p">
            <div data-id="element-313" data-mp="29g0vdbcyt2v4">
              <p className="flex items-baseline gap-2" data-id="element-314" data-mp="29gkg0zu025cu">
                <span className="font-display text-3xl leading-none text-amber" data-id="element-315" data-mp="2ed16i0oo8vt3">$27</span>
                <span className="text-xs leading-none text-cream-muted line-through" data-id="element-316" data-mp="2iew3iszkkn12">$97</span>
              </p>
              <p className="mt-1 text-[10px] uppercase tracking-label text-cream-muted" data-id="element-317" data-mp="2n6e95ucjfbsd">
                Launch price today
              </p>
            </div>
            <CtaButton data-id="element-318" data-mp="2s7lgjsarq8yi">Get it now</CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}